import { User } from '@prisma/client'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { AppSessionType } from '~/features/appSession/common'
import { Toolbox } from '~/plugins/toolbox/shared'
import { OnboardingValues } from '../../common'
import { StepEmailProviders } from './components/StepEmailProviders'
import { StepEmailToggle } from './components/StepEmailToggle'

type Props = {
  user: User
  appSession: AppSessionType
  onSubmit: () => void
}

export const Onboarding: React.FC<Props> = ({ user, appSession, onSubmit }) => {
  const valuesDefault: Partial<OnboardingValues> = {
    emailServices: {
      isActive: true,
      provider: 'gmail',
    },
  }
  return (
    <>
      <CommonClient.Onboarding.Wrapper<OnboardingValues>
        appSession={appSession}
        valuesDefault={valuesDefault}
        onSubmitted={onSubmit}
        steps={[
          {
            key: 'toggle',
            content: props => (
              <StepEmailToggle
                {...props}
                canNext={values =>
                  Toolbox.Utility.isDefined(values.emailServices?.isActive)
                }
              />
            ),
          },
          {
            key: 'emailServices',
            content: props => (
              <StepEmailProviders
                user={user}
                {...props}
                canNext={values =>
                  (values.authorizations?.gmailDraftEmails &&
                    values.authorizations?.gmailReadEmails) ||
                  values.emailServices?.outlookProviderAccountId
                }
              />
            ),
          },
        ]}
      ></CommonClient.Onboarding.Wrapper>
    </>
  )
}
